import React, { Component } from "react"
import { Helmet } from "react-helmet"
import Disqus from "gatsby-plugin-disqus"
import { Link } from "gatsby"

const styles = {
  container: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 600,
    paddingLeft: 15,
    paddingRight: 15,
  },
  navLinks: {
    width: "100%",
    position: "relative",
    paddingTop: 40,
    marginBottom: 40,
  },
  leftButton: {
    float: "left",
  },
  rightButton: {
    float: "right",
    textAlign: "right",
  },
}

export default class Template extends Component {
  componentDidMount() {
    document.body.style.overflow = "auto"
  }

  render() {
    const {
      data,
      pageContext: { prev, next },
    } = this.props
    const { markdownRemark: post } = data

    return (
      <div style={styles.container}>
        <Helmet>
          <title>"{post.frontmatter.title}" - from Joe Beuckman</title>
          <meta name="keywords" content={post.frontmatter.tags.join(", ")} />
        </Helmet>

        <div style={{ display: "table-row" }}>
          <div style={{ display: "table-cell", paddingRight: 7 }}>
            <a href="/">
              <img
                alt="Go Home"
                height="30"
                src="/home_icon.png"
                style={{ verticalAlign: "text-bottom" }}
              />
            </a>
          </div>
          <div style={{ display: "table-cell" }}>
            <h1>{post.frontmatter.title}</h1>
          </div>
        </div>
        <time dateTime={post.frontmatter.date}>{post.frontmatter.date}</time>
        <dl>
          {post.frontmatter.tags.map(tag => (
            <span style={{ marginRight: 8 }}>
              <Link to={`/tags/${tag}`}>{tag}</Link>
            </span>
          ))}
        </dl>

        <article dangerouslySetInnerHTML={{ __html: post.html }} />

        <div style={styles.navLinks}>
          {prev && (
            <span style={styles.leftButton}>
              <div>
                <a href={prev.frontmatter.path}>&lt; newer</a>
              </div>
              <div>
                <em>{prev.frontmatter.title}</em>
              </div>
            </span>
          )}
          {next && (
            <span style={styles.rightButton}>
              <div>
                <a href={next.frontmatter.path}>older &gt;</a>
              </div>
              <div>
                <em>{next.frontmatter.title}</em>
              </div>
            </span>
          )}
          <div style={{ clear: "both", height: 1 }} />
        </div>

        <Disqus
          identifier={post.id}
          title={post.frontmatter.title}
          url={this.props.location.href}
        />
      </div>
    )
  }
}

export const postQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        date
        tags
      }
    }
  }
`
